"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const text_1 = require("../../utils/text");
const modal_header_style_1 = __importDefault(require("./modal.header.style"));
const iconbutton_1 = require("../iconbutton");
class ModalHeader extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, titleId, title, closeButtonLabel, handleClose, hideCloseButton, hideHeaderBorderBottom } = this.props;
            const parsedTitle = typeof title === 'string' ? text_1.parseBoldMarkdown(title) : title;
            return (jsx_runtime_1.jsxs("header", Object.assign({ className: classes.root, "data-has-borderbottom": !hideHeaderBorderBottom }, { children: [jsx_runtime_1.jsx("h1", Object.assign({ className: classes.title, id: titleId }, { children: parsedTitle }), void 0),
                    !hideCloseButton && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.closeButton }, { children: jsx_runtime_1.jsx(iconbutton_1.IconbuttonClose, { label: closeButtonLabel, onClick: handleClose }, void 0) }), void 0))] }), void 0));
        };
    }
}
exports.ModalHeader = ModalHeader;
ModalHeader.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    titleId: prop_types_1.default.string.isRequired,
    title: prop_types_1.default.node.isRequired,
    closeButtonLabel: prop_types_1.default.string.isRequired,
    handleClose: prop_types_1.default.func.isRequired,
    hideCloseButton: prop_types_1.default.bool,
    hideHeaderBorderBottom: prop_types_1.default.bool
};
ModalHeader.defaultProps = {
    hideCloseButton: false,
    hideHeaderBorderBottom: false
};
exports.default = react_jss_1.default(modal_header_style_1.default)(ModalHeader);
//# sourceMappingURL=modal.header.js.map